import { PLATFORMS } from '@constants';

export const socialNetworksLinks = {
  [PLATFORMS.FRANCE]: [
    {
      id: 'tw',
      href: 'https://twitter.com/ManoMano_FR',
      dataQa: 'contactTwitterCta',
      name: 'Twitter',
    },
    {
      id: 'f',
      href: 'https://www.facebook.com/manomanoFR/',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'pin',
      href: 'https://www.pinterest.fr/manomano_FR/',
      dataQa: 'contactPinterestCta',
      name: 'Pinterest',
    },
    {
      id: 'inst',
      href: 'https://www.instagram.com/manomano.fr/',
      dataQa: 'contactInstagramCta',
      name: 'Instagram',
    },
  ],
  [PLATFORMS.SPAIN]: [
    {
      id: 'tw',
      href: 'https://twitter.com/ManoMano_ES',
      dataQa: 'contactTwitterCta',
      name: 'Twitter',
    },
    {
      id: 'f',
      href: 'https://www.facebook.com/ManoMano.es',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'inst',
      href: 'https://www.instagram.com/manomano.es/',
      dataQa: 'contactInstagramCta',
      name: 'Instagram',
    },
    {
      id: 'yt',
      href: 'https://www.youtube.com/channel/UCQ4Ry8e-4Y7CJUVx277hWJA',
      dataQa: 'contactYouTubeCta',
      name: 'Youtube',
    },
  ],
  [PLATFORMS.ITALY]: [
    {
      id: 'tw',
      href: 'https://twitter.com/ManoMano_IT',
      dataQa: 'contactTwitterCta',
      name: 'Twitter',
    },
    {
      id: 'f',
      href: 'https://www.facebook.com/manomanoitalia',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'inst',
      href: 'https://www.instagram.com/manomano.it',
      dataQa: 'contactInstagramCta',
      name: 'Instagram',
    },
    {
      id: 'yt',
      href: 'https://www.youtube.com/channel/UCv21PK58Zz27gL90IGS-Sdg',
      dataQa: 'contactYouTubeCta',
      name: 'Youtube',
    },
  ],
  [PLATFORMS.GREAT_BRITAIN]: [
    {
      id: 'tw',
      href: 'https://twitter.com/ManoMano_UK',
      dataQa: 'contactTwitterCta',
      name: 'Twitter',
    },
    {
      id: 'f',
      href: 'https://www.facebook.com/manomanoUK/',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'pin',
      href: 'https://uk.pinterest.com/ManoManoUK/',
      dataQa: 'contactPinterestCta',
      name: 'Pinterest',
    },
  ],
  [PLATFORMS.GERMANY]: [
    {
      id: 'tw',
      href: 'https://twitter.com/ManoMano_de',
      dataQa: 'contactTwitterCta',
      name: 'Twitter',
    },
    {
      id: 'f',
      href: 'https://www.facebook.com/manomanode',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'yt',
      href: 'https://www.youtube.com/channel/UCip55scEHV8-DTjx5v7cWuQ',
      dataQa: 'contactYouTubeCta',
      name: 'Youtube',
    },
    {
      id: 'inst',
      href: 'https://www.instagram.com/manomano.de/?hl=de',
      dataQa: 'contactInstagramCta',
      name: 'Instagram',
    },
  ],
};
